




























import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ProfileDocumentsView extends Vue {
  userDocuments = []

  async mounted() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

    const userTermsOfUseData = await this.getCadastroMedicoStore.getUserTermsOfUse()
    this.userDocuments = userTermsOfUseData

    EventBus.$emit('clearLoadingRequest')
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  async openDocumentDetails(document: {
    nomeDoDocumento: string,
    tipo: string,
    hospitalId: string,
  }) {
    const { tipo: documentType, hospitalId } = document

    if (documentType === 'TermoDeUso') {
      this.$router.push({ name: 'hospital-terms-of-use', params: { hospitalId } })
    }
  }
}
